import React from 'react';
import { FormattedMessage } from 'react-intl';
interface PropTypes {
  ribbonTextId: string;
}

/**
 * Component for personalized ribbon text.
 */
const PersonalizedRibbon: React.FC<PropTypes> = ({ ribbonTextId }) => {
  if (!ribbonTextId) {
    return null;
  }

  return (
    <div className="bg-primary-main text-other-white mt-0.5 w-full text-xs md:px-0 lg:p-0 lg:text-sm">
      <div>
        <FormattedMessage
          id={ribbonTextId}
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      </div>
    </div>
  );
};

export default PersonalizedRibbon;
